import { MapObject } from "./map-object";
import { PJ } from "app/shared/data/pj";

export class PJDuplicate {
    
    constructor(public pj1: PJ, public pj2: PJ) {}

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/pjDuplicate.ts